import React from 'react'
import { AuthProvider } from './context/Authcontext'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Approutes from './Approutes';
import { ToastContainer } from 'react-toastify';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Approutes />
      </Router>
      <ToastContainer />
    </AuthProvider>
  )
}
